import { createFileRoute, redirect } from "@tanstack/react-router"

// Old detail URL — role pages now live at /jobs/$jobId.
export const Route = createFileRoute("/jobs_/browse/$jobId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/jobs/$jobId",
      params: { jobId: params.jobId },
    })
  },
  component: () => null,
})
